<template>
  <footer class="footer py-4 text-white">
    <div class="container">
      <!-- ===== ACADEMY INFO ===== -->
      <div class="academy-section text-center mb-3">
        <h5 class="text-pink fw-bold mb-2">Axion Science Academy</h5>
        <p class="mb-1">
          <i class="bi bi-geo-alt-fill me-1"></i> 45 Knowledge Street, Science
          City, Sri Lanka
        </p>
        <p class="mb-1">
          <i class="bi bi-envelope-fill me-1"></i> contact@axionscience.lk |
          <i class="bi bi-telephone-fill me-1"></i> +94 77 123 4567
        </p>
        <div class="social-icons mt-2">
          <a href="#" class="me-3"><i class="bi bi-facebook"></i></a>
          <a href="#" class="me-3"><i class="bi bi-twitter"></i></a>
          <a href="#" class="me-3"><i class="bi bi-instagram"></i></a>
          <a href="#"><i class="bi bi-youtube"></i></a>
        </div>
      </div>

      <hr class="border-pink" />

      <!-- ===== DEVELOPER INFO ===== -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-center"
      >
        <div class="footer-bottom mb-2 mb-md-0 text-center text-md-start">
          <span class="small">
            Developed & Powered by
            <a
              href="https://mysoftcode.com"
              target="_blank"
              class="neon-blue text-decoration-none"
            >
              <strong>MySoftCode</strong>
            </a>
            | <i class="bi bi-telephone-fill me-1"></i> +94 71 324 6947 |
            <a
              href="https://wa.me/94713246947"
              target="_blank"
              class="text-decoration-none text-success"
            >
              <i class="bi bi-whatsapp me-1">+94 71 324 6947</i> 
            </a>
            | <i class="bi bi-envelope-fill me-1"></i> info@mysoftcode.com
          </span>
        </div>

        <div class="copyright text-center text-md-end">
          <span class="small text-muted">
            &copy; {{ currentYear }} Axion Science Academy. All rights reserved.
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();
</script>

<style scoped>
.footer {
  background: #0d0010;
  color: #ccc;
  font-size: 0.875rem;
}

.text-pink {
  color: #ff00cc;
  font-weight: 600;
}

.social-icons a {
  color: #ccc;
  font-size: 20px;
  margin-right: 10px;
  transition: 0.3s;
}

.social-icons a:hover {
  color: #ff00cc;
  text-shadow: 0 0 8px #ff00cc;
}

hr.border-pink {
  border-top: 1px solid #ff00cc;
  margin: 0.5rem 0 1rem 0;
}

.footer-bottom span,
.copyright span {
  display: inline-block;
}

@media (max-width: 576px) {
  .social-icons a {
    font-size: 18px;
    margin-right: 8px;
  }
  .footer-bottom,
  .copyright {
    text-align: center !important;
  }
}
</style>
